import { useState, useContext } from "react";
import AppContext from '../../contexts/AppContext';
import {Button, TextField, Stack} from "@mui/material";
import apiFetch from "../../helperFunctions/api";
import useAsyncAction from "../../helperFunctions/useAsyncAction";

export default function AddRaidTeam() {

  const [newTeamName, setNewTeamName] = useState('')
  let {API, getRaidTeams} = useContext(AppContext);
  const { pending, error, run } = useAsyncAction();


  function submitNewRaidTeam(newTeamName){
    run(async () => {
    let body = { newTeamName};

    body = JSON.stringify(body);
    const response = await apiFetch(`${API}/raidteam`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body,
    });
    if (!response.ok) throw new Error("Unable to create raid team.");
    setNewTeamName('');
    getRaidTeams();
    });
  }


  return (
    <Stack spacing={0.5}>
      <TextField
        onChange={(e) => setNewTeamName(e.target.value)}
        label={"Create new Raid Team"}
        value={newTeamName}
        disabled={pending}
        error={Boolean(error)}
        helperText={error}
      />
      <Button disabled={pending || !newTeamName.trim()} onClick={() => submitNewRaidTeam(newTeamName)} variant="outlined">
        Submit
      </Button>
    </Stack>
  );
}
